import React from 'react'
import DeactivateYourAccountForm from '../UI/Form/DeactivateYourAccountForm';
import PrimaryModal from '../UI/Modal/PrimaryModal';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const DeactivateYourAccount = ( { setDeactivateAccount }) => {
  const { content } = useContentfulContext();

  return (
    <PrimaryModal hideModal={setDeactivateAccount} title={content.DEACTIVATE_YOUR_ACCOUNT.title}>
    <div className="w-full px-4 md:px-8 my-6">
        <div className="flex flex-col space-y-2 mb-6">
            <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">{ content.DEACTIVATE_YOUR_ACCOUNT.title }</h1>
            <p>{ content.DEACTIVATE_YOUR_ACCOUNT.description_1 }</p>
        </div>
        <div className="space-y-7 w-full md:max-w-[520px] w-full">
            <DeactivateYourAccountForm handleCancelClick={() => { setDeactivateAccount(false) }}/>
        </div>
    </div>
    </PrimaryModal>
  )
}

export default DeactivateYourAccount;